<template>
    <v-container>
        <app-bar :menu="appMenu"
                 @addToMenu="_addToMenu"
        ></app-bar>

        <v-card tile v-for="event in events" :key="event.container_id" class="mb-5">

            <v-row no-gutters>
                <v-col>
                    <v-card-title>{{event.title}}</v-card-title>
                    <v-card-subtitle>{{event.club_name}}</v-card-subtitle>
                </v-col>
                <v-col cols="3">
                    <v-card min-width="100%" tile flat dark width="70"
                            class="pa-3 align-self-center text-center font-weight-bold"
                            v-html="eventDate(event.from_date,event.to_date)">
                    </v-card>
                </v-col>
            </v-row><!--
            <v-row no-gutters>

            </v-row>-->


            <v-img class="elevation-5 bg-cover" :height="coverHeight" :src="getCoverEvent(event.container_id)">

                <template v-slot:placeholder>
                    <v-progress-linear color="black" height="2" indeterminate></v-progress-linear>
                </template>

            </v-img>

            <v-container class="pb-0 mb-0 text-center">
                <v-row>
                    <v-col>
                        <v-icon size="30">mdi-av-timer</v-icon>
                        <span class="d-block font-weight-light">Durata<br><strong>{{event.duration}} ore</strong></span>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col>
                        <v-icon size="30">mdi-bullseye</v-icon>
                        <span class="d-block font-weight-light">Tipologia<br><strong>{{event.game_type}}</strong></span>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col>
                        <v-icon size="30">mdi-map-search</v-icon>
                        <span class="d-block font-weight-light">Provincia di<br><strong>{{event.province}}</strong></span>
                    </v-col>
                </v-row>
            </v-container>

            <v-btn color="secondary" tile :href="event.link" x-large block>Vai all'evento</v-btn>

        </v-card>

        <div v-if="!allLoaded" class="text-center my-3">
            <v-btn v-intersect="{
                                    handler: loadMore,
                                    options: {
                                       rootMargin:'0px 0px -100px 0px',
                                       threshold: [0.75]
                                    }
                                  }"
                   fab small loading>
            </v-btn>
        </div>

    </v-container>
</template>

<script>
    import axios from 'axios';
    import {mapMutations, mapActions} from 'vuex'

    export default {
        name: "Events",
        data() {
            return {
                appMenu: [
                    {text: 'Aggiungi al Menù', icon: 'mdi-pin', action: 'addToMenu'},
                ],
                allLoaded: false,
                loadingMoreData: false,
                events: [],
                limit: 3,
                offset: 0,
                coords: false,

                coverHeight: 140
            }
        },
        mounted() {
            this.setLoading(true);
            setTimeout(() => {
                this.getEvents();
            }, 100);
        },
        methods: {
            ...mapMutations([
                'setLoading',
            ]),
            ...mapActions([
                '_addToMenu'
            ]),
            gotoEvent(link){
                location.href = link;
            },
            async getEvents() {
                if (this.allLoaded) {
                    return;
                }
                await axios
                    .post(this.$store.state.ROOT_API + '/events',
                        {
                            limit: this.limit,
                            offset: this.events.length
                        }
                    )
                    .then(resp => {
                        if (resp.data.length === 0) {
                            this.allLoaded = true;
                        }
                        this.setLoading(false);
                        this.events.push.apply(this.events, resp.data);
                        console.log(resp.data);
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
            loadMore(entries, observer, isIntersecting) {
                this.loadingMoreData = isIntersecting;
                if (isIntersecting && this.loadingMoreData) {
                    if (this.events.length) {
                        this.getEvents();
                    }
                }
            },
            getCoverEvent(event_id) {
                return 'https://italiasoftair.it/storage/events/' + event_id + '/' + event_id + '.jpg';
            },
            eventDate(from_date, to_date) {
                let month = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
                let fd = new Date(from_date);
                let td = new Date(to_date);
                if (from_date === to_date) {
                    return fd.getDate() + '<br>' + month[fd.getMonth()] + '<br>' + fd.getFullYear();
                }

                let d = '';

                d += fd.getDate();

                if (fd.getMonth() !== td.getMonth()) {
                    d += ' ' + month[fd.getMonth()];
                    d += '<br>' + td.getDate() + ' ' + month[td.getMonth()];
                }

                if (fd.getMonth() === td.getMonth()) {
                    d += '-' + td.getDate();
                    d += '<br>' + month[fd.getMonth()];
                }

                d += '<br>' + td.getFullYear();

                return d;
            }
        }
    }
</script>

<style scoped>
    .bg-cover {
        background-image: url('https://italiasoftair.it/images/assets/cover-default.jpg');
        background-position: center center;
        background-size: cover;
    }
</style>